import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { pageRoutes } from "../routes/PageRoutes";

const SubHeader = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const backButtonPaths = [
    pageRoutes?.update_boat,
    pageRoutes?.add_new_docks,
    pageRoutes?.changePassword,
    pageRoutes?.update_business_profile,
    pageRoutes?.business_profile,
    pageRoutes?.AssignBoat,
    pageRoutes?.update_docks,
    pageRoutes?.dock_details,
    pageRoutes?.boat_detail,
    pageRoutes?.crate_boat,
    pageRoutes?.AssignDock,
    pageRoutes?.TechnicianDetail,
    pageRoutes?.SupplierDetail,
    pageRoutes?.AddSupplier,
    pageRoutes?.AddTechnician,
    pageRoutes?.EditTechnician,
    pageRoutes?.subscription,
    pageRoutes?.invoice_detail,
    pageRoutes?.CustomerDetail,
    pageRoutes?.maintained_boats,
    pageRoutes?.boat_tracer,
    pageRoutes?.JobDetail,
    pageRoutes?.MaintenanceDetails,
    pageRoutes?.CreateMaintenance,
    pageRoutes?.ManageServicePresets,
    pageRoutes?.task_review,
// new pages
      pageRoutes?.CustomerRequestDetail,
      pageRoutes?.CreateQuote,
      pageRoutes?.QuotesDetail,
        pageRoutes?.quotes,
  ];

  const shouldShowBackIcon = backButtonPaths.includes(pathname);
  const pageConfig = {
    [pageRoutes?.AssignDock]: {
      title: "Assign Boat to Dock",
      subtitle: "Enter dock details to create a new dock",
    },
    [pageRoutes?.task_review]: {
      title: "Task Review",
      subtitle: "",
    },
    [pageRoutes?.update_boat]: {
      title: "Edit Boat",
      subtitle: "Edit essential information to register a new boat",
    },
    [pageRoutes?.crate_boat]: {
      title: "Add Boat",
      subtitle: "Add essential information to register a new boat",
    },
    [pageRoutes?.boat_detail]: {
      title: "Boat Details",
      subtitle: "Update dock details and capacity",
    },
    [pageRoutes?.add_new_docks]: {
      title: "Add Dock",
      subtitle: "Enter dock details to create a new dock.",
    },
    [pageRoutes?.update_docks]: {
      title: "Edit Dock",
      subtitle: "Update dock details and capacity",
    },
    [pageRoutes?.dock_details]: {
      title: "Dock Details",
      subtitle: "View and track details",
    },
    [pageRoutes?.AssignBoat]: {
      title: "Assign Boat to Dock",
      subtitle: "Enter dock details to create a new dock.",
    },
    [pageRoutes?.changePassword]: {
      title: "Change Password",
      subtitle: "Update your account password to keep your access secure.",
    },
    [pageRoutes?.update_business_profile]: {
      title: "Edit Profile",
      subtitle: "Update your profile information and account details.",
    },
    [pageRoutes?.business_profile]: {
      title: "My Profile",
      subtitle: "Your profile information and account details.",
    },
    [pageRoutes?.subscription]: {
      title: "My Subscriptions",
      subtitle:
        "Keep your information up to date and manage your personal details.",
    },
    [pageRoutes?.TechnicianDetail]: {
      title: "Technician Details",
      subtitle: "View and manage user information",
    },
    [pageRoutes?.SupplierDetail]: {
      title: "Supplier Details",
      subtitle: "View and manage user information",
    },
    [pageRoutes?.AddSupplier]: {
      title: "Add Supplier",
      subtitle: "Add supplier details to enable services and collaboration.",
    },
    [pageRoutes?.AddTechnician]: {
      title: "Add Technician",
      subtitle: "Add Technician Member details and enable them for job assignments.",
    },
    [pageRoutes?.EditTechnician]: {
      title: "Edit Technician",
      subtitle: "Edit Staff Member details for job assignments.",
    },
    [pageRoutes?.invoice_detail]: {
      title: "View Invoice ",
      subtitle: "View your invoice details ",
    },
    [pageRoutes?.CustomerDetail]: {
      title: "Customer Details",
      subtitle: "View and manage customer information",
    },
    [pageRoutes?.maintained_boats]: {
      title: "Maintained Boats",
      subtitle: "View and manage your maintained boats",
    },
    [pageRoutes?.boat_tracer]: {
      title: "Completed jobs",
      subtitle: "View and manage boats jobs that is completed.",
    },
    [pageRoutes?.JobDetail]: {
      title: "Job Details",
      subtitle: "View and manage job information",
    },
    [pageRoutes?.MaintenanceDetails]: {
      title: "Maintenance Details",
      subtitle: "View Maintenance details and owner’s details",
    },
    [pageRoutes?.CreateMaintenance]: {
      title: "Create Maintenance ",
      subtitle: "Define Maintenance  details and assign resources to begin work",
    },
    [pageRoutes?.ManageServicePresets]: {
      title: "Manage Service Presets",
      subtitle: "Add, edit, delete, view preset services",
    },


    // new pages
    [pageRoutes?.CustomerRequestDetail]: {
      title: "Request Details",
      subtitle: "Quote has been sent to the customer. Waiting for approval.",
    },
      [pageRoutes?.CreateQuote]: {
      title: "Create Quote",
      subtitle: "Select services and define labour cost to generate a quote.",
    },
      [pageRoutes?.QuotesDetail]: {
      title: "Quote Details",
      subtitle: "Waiting for customer approval",
    },
        [pageRoutes?.quotes]: {
      title: "Quote ",
      subtitle: "Track and manage all service quotes sent to customers.",
    },
  };


  

  const currentPage = pageConfig[location.pathname] || {
    title: "Default",
    subtitle: "",
  };

  return (
    <div className="d-flex align-items-center gap-4  flex-wrap justify-content-between">
      <div className="d-flex align-items-center gap-4 ">
        {shouldShowBackIcon && (
          <div
            className="ct_back_btn"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
          >
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.21934 7.29889C0.0788896 7.15826 0 6.96764 0 6.76889C0 6.57014 0.0788896 6.37952 0.21934 6.23889L6.21934 0.238889C6.288 0.165202 6.3708 0.1061 6.4628 0.0651083C6.5548 0.0241165 6.65412 0.0020752 6.75482 0.0002985C6.85552 -0.0014782 6.95555 0.017046 7.04894 0.0547667C7.14233 0.0924873 7.22716 0.148633 7.29838 0.219851C7.3696 0.29107 7.42574 0.375904 7.46346 0.469293C7.50118 0.562681 7.51971 0.662708 7.51793 0.763412C7.51616 0.864115 7.49411 0.963429 7.45312 1.05543C7.41213 1.14743 7.35303 1.23023 7.27934 1.29889L2.55934 6.01889H16.7493C16.9483 6.01889 17.139 6.09791 17.2797 6.23856C17.4203 6.37921 17.4993 6.56998 17.4993 6.76889C17.4993 6.9678 17.4203 7.15857 17.2797 7.29922C17.139 7.43987 16.9483 7.51889 16.7493 7.51889H2.55934L7.27934 12.2389C7.35303 12.3076 7.41213 12.3904 7.45312 12.4824C7.49411 12.5744 7.51616 12.6737 7.51793 12.7744C7.51971 12.8751 7.50118 12.9751 7.46346 13.0685C7.42574 13.1619 7.3696 13.2467 7.29838 13.3179C7.22716 13.3891 7.14233 13.4453 7.04894 13.483C6.95555 13.5207 6.85552 13.5393 6.75482 13.5375C6.65412 13.5357 6.5548 13.5137 6.4628 13.4727C6.3708 13.4317 6.288 13.3726 6.21934 13.2989L0.21934 7.29889Z"
                fill="white"
              />
            </svg>
          </div>
        )}
        <div>
          <h4 className="ct_fs_26 ct_ff_ProximaNova_semibold mb-0">
            {currentPage.title}{" "}
          </h4>
          <p className="mb-0 ct_text_para ct_fs_18 ct_ff_ProximaNova_regular">
            {currentPage.subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
